import { PostResponse } from '../../../types/models/posts';
import { User } from '../../../types/models/user';
import { Reaction } from '../../../types/models/reaction';
import { UserComment } from '../../../types/models/user-comment';

const DEMO_POST_DATE = new Date().toUTCString();
const DEMO_POST_TEXT = 'Demo post text';
const DEMO_UID = '1234123412341234';
const DEMO_POST_USER: User = {
  uid: DEMO_UID,
  name: 'Bobby'
};
const DEMO_POST_REACTION: Reaction = {
  uid: DEMO_UID,
  type: 'DISLIKE',
  authorUid: '1234125',
  createdAt: DEMO_POST_DATE
};
const DEMO_POST_COMMENT: UserComment = {
  uid: DEMO_UID,
  author: DEMO_POST_USER,
  createdAt: DEMO_POST_DATE,
  text: DEMO_POST_TEXT
};
export const DEMO_POST_RESPONSE_DATA: PostResponse = {
  body: {
    uid: DEMO_UID,
    author: DEMO_POST_USER,
    authorUid: DEMO_POST_USER.uid,
    text: DEMO_POST_TEXT,
    createdAt: DEMO_POST_DATE,
    reactions: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
    comments: [DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT]
  },
  likes: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
  dislikes: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
  stats: {
    likes: 21,
    dislikes: 4,
    comments: 12
  }
};
// const DEMO_POST_DATA: Post = {
//   uid: DEMO_UID,
//   author: DEMO_POST_USER,
//   text: DEMO_POST_TEXT,
//   createdAt: DEMO_POST_DATE,
//   likes: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
//   dislikes: [DEMO_POST_REACTION],
//   comments: [DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT]
// };

function getDemoPost(text: string): PostResponse {
  return {
    body: {
      uid: DEMO_UID,
      author: DEMO_POST_USER,
      authorUid: DEMO_POST_USER?.uid || DEMO_UID,
      text: text,
      createdAt: DEMO_POST_DATE,
      reactions: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
      comments: [DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT, DEMO_POST_COMMENT]
    },
    likes: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
    dislikes: [DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION, DEMO_POST_REACTION],
    stats: {
      likes: 21,
      dislikes: 4,
      comments: 12
    }
  };
}

const demoPosts: PostResponse[] = [
  getDemoPost("Everyone on the team thinks that the release date in two weeks is realistic. Lora and I think it's impossible to do. We need an extra week to make it happen. Otherwise, we will release a raw and buggy product."),
  getDemoPost('My resolution for this year is to run a marathon.'),
  getDemoPost('The prediction for Grammy 2021: Best Pop Solo Performance “Everything I Wanted” — Billie Eilish in gonna be a winner'),
  getDemoPost('Challenge: no social media for 30 days from today.')
];

function getRandomPostData(posts: PostResponse[]): PostResponse {
  return posts[Math.floor(Math.random() * posts.length)];
}

export default () => getRandomPostData(demoPosts);
